import axios from 'axios';

import React from 'react';
import ModalForm from '../../../components/ModalForm';
import { selectionRequired } from '../../../helpers/utils';
import Alert from '../../../helpers/alert';
import { ERR_MSG } from '../../../globalConstants';

import { createSelectOptions } from '../../../helpers/utils';

interface ClientTransferFormModalProps {
  agencies: any[];
  agencyID: any;
  agencyClients: any[];
  isOpenClientTransferModal: boolean;
  toggleOpenClientTransferModal: (val?: boolean) => void;
  fetchAgencyData?: () => void;
}

const ClientTransferFormModal = ({
  agencies,
  agencyID,
  agencyClients,
  isOpenClientTransferModal,
  toggleOpenClientTransferModal,
}: ClientTransferFormModalProps) => {
  const clientOptions = createSelectOptions(agencyClients);
  const agencyOptions = createSelectOptions(agencies);

  const handleSubmitTransfer = async (values: any) => {
    const payload = new FormData();
    payload.append('agency_id', agencyID);
    payload.append('destinationAgency', values.destination);
    payload.append('clientTarget', values['client-target']);
    try {
      await axios.post('/admin/transfer-client', payload);
      Alert.success(`Transfer has queued.`);
      toggleOpenClientTransferModal(false);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      Alert.error(ERR_MSG);
    }
  };

  const clientTransferModalField = [
    {
      name: 'client-target',
      label: 'Client to Transfer',
      id: 'client-target-edit-field',

      component: 'select',
      type: 'dropdown',
      options: clientOptions,
      validate: selectionRequired,
    },
    {
      name: 'destination',
      label: 'Destination Agency',
      id: 'destination-edit-field',
      component: 'select',
      options: agencyOptions,
      type: 'dropdown',
      validate: selectionRequired,
    },
  ];

  return (
    <ModalForm
      title="Client Transfer"
      isOpen={isOpenClientTransferModal}
      onSubmit={handleSubmitTransfer}
      onClose={toggleOpenClientTransferModal}
      fields={clientTransferModalField}
      oneColumn
      buttonText="Transfer Client"
    />
  );
};

export default ClientTransferFormModal;
